import { fetch } from 'utils/fetch';

export default {
  getLineContract(id) {
    return fetch({
      url: `/api/payment/schedule/query/extends/message/by/id?id=${id}`,
      method: 'GET',
    });
  },
  getContractDetail(documentOID, params) {
    return fetch({
      url: `/contract/api/contract/header/v2/${documentOID}`,
      method: 'GET',
      params,
    });
  },
  getPayList(documentOID, params) {
    return fetch({
      url: `/contract/api/contract/line/v2/herder/${documentOID}`,
      method: 'GET',
      params,
    });
  },
  getHistory(params) {
    return fetch({
      url: '/api/approval/history/get/common',
      method: 'GET',
      params,
    });
  },
  getCustomForm(formOID) {
    return fetch({
      url: `/api/custom/forms/${formOID}`,
      method: 'GET',
    });
  },
  getContractHeaderInfo(id) {
    return fetch({
      url: `/contract/api/contract/header/${id}`,
      method: 'GET',
    });
  },
  getChangeHistory(params) {
    return fetch({
      url: '/api/contract/operation/history',
      method: 'GET',
      params,
    });
  },
  getContractBudgetList(params) {
    return fetch({
      url: '/api/contract/budget/line',
      method: 'GET',
      params,
    });
  },
  getContractList(params) {
    return fetch({
      url: '/contract/api/contract/header/update/query',
      method: 'GET',
      params,
    });
  },
  getAuthorizedContractList(params) {
    return fetch({
      url: '/contract/api/contract/header/auth/query',
      method: 'GET',
      params,
    });
  },
  getStatusCount(params) {
    return fetch({
      url: '/contract/api/contract/header/stats/type/get',
      method: 'GET',
      params,
    });
  },

  getSystemValueList(params) {
    return fetch({
      url: '/api/custom/enumerations/template/by/type',
      method: 'GET',
      params,
    });
  },
  //保存合同头信息
  saveContractInfo(params) {
    return fetch({
      url: '/contract/api/contract/header',
      method: 'PUT',
      data: params,
    });
  },
  // 更新合同头信息
  updateContractInfo(params) {
    return fetch({
      url: '/contract/api/contract/header/edit',
      method: 'PUT',
      data: params,
    });
  },
  // 保存合同付款行
  newPayPlan(params) {
    return fetch({
      url: '/contract/api/contract/line',
      method: 'POST',
      data: params,
    });
  },
  // 更新合同付款行
  updatePayPlan(params) {
    return fetch({
      url: '/contract/api/contract/line',
      method: 'PUT',
      data: params,
    });
  },
  // 删除合同付款行
  deletePayPlan(id) {
    return fetch({
      url: `/contract/api/contract/line/${id}`,
      method: 'DELETE',
    });
  },
  // 删除合同预算行
  deleteContractBudget(id) {
    return fetch({
      url: `/contract/api/contract/budget/${id}`,
      method: 'DELETE',
      nativeResponseSerializer: 'boolean',
    });
  },
  // 删除合同预标的物行
  deleteContractSubjectMatterLine(id) {
    return fetch({
      url: `/contract/api/contract/subject/matter/${id}`,
      method: 'DELETE',
      nativeResponseSerializer: 'boolean',
    });
  },
  // 获取合同预算的默认分摊
  getContractDefaultApportion(params) {
    return fetch({
      url: '/api/contract/budget/default/apportionment',
      method: 'POST',
      data: params,
    });
  },
  // 保存合同预算行
  saveBudgetLine(params) {
    return fetch({
      url: '/api/contract/budget/line',
      method: 'POST',
      data: params,
    });
  },
  // 校验合同总金额是否超过采购申请单的可关联金额
  getIsExcessAmount(params) {
    return fetch({
      url: '/contract/api/contract/header/amount/check',
      method: 'POST',
      data: params,
    });
  },
  // 提交合同
  submitContract(id, ignoreWarning, ignoreCheckWarning) {
    return fetch({
      url: `/contract/api/contract/header/v2/submit/${id}`,
      method: 'PUT',
      data: { id, ignoreWarning, ignoreCheckWarning },
    });
  },
  // 可续签合同
  getContractRelateList(data, { page, size }) {
    return fetch({
      url: `/contract/api/contract/header/associate/query?page=${page}&size=${size}`,
      method: 'POST',
      data,
    });
  },
  postContractV2(data) {
    return fetch({
      url: '/contract/api/contract/header/edit/v2',
      method: 'PUT',
      data: data.params,
    });
  },
  //保存合同信息
  postContract(data) {
    let url, method;
    const { params, type } = data;
    if (type === 'CREATE') {
      url = '/contract/api/contract/header/init/contract/header';
      method = 'POST';
    } else {
      url = '/contract/api/contract/header';
      method = 'PUT';
    }
    return fetch({
      url,
      method,
      data: params,
    });
  },

  //根据合同类型ID查询合同类型信息
  getContractTypeInfo(id) {
    return fetch({
      url: `/contract/api/contract/type/${id}`,
      method: 'GET',
    });
  },
  // 撤回合同不走工作流
  withdrawContract(id) {
    return fetch({
      url: `/contract/api/contract/header/withdrawal/${id}`,
      method: 'PUT',
    });
  },
  // 撤回合同
  withdrawWorkflowContract(data) {
    return fetch({
      url: '/api/approvals/withdraw',
      method: 'POST',
      data,
    });
  },
  // 合同变更
  changeContract(id) {
    return fetch({
      url: '/contract/api/contract/header/contract/change',
      method: 'PUT',
      data: { id },
    });
  },
  //合同取消变更
  unChangeContract(id) {
    return fetch({
      url: '/contract/api/contract/header/contract/cancel/change',
      method: 'PUT',
      data: { id },
    });
  },
  // 合同暂挂
  holdContract(id) {
    return fetch({
      url: `/contract/api/contract/header/hold/${id}`,
      method: 'PUT',
    });
  },
  // 合同取消暂挂
  unHoldContract(id) {
    return fetch({
      url: `/contract/api/contract/header/unHold/${id}`,
      method: 'PUT',
    });
  },
  // 合同取消
  cancelContract(id) {
    return fetch({
      url: `/contract/api/contract/header/cancel/${id}`,
      method: 'PUT',
    });
  },
  // 合同已完成
  finishContract(id) {
    return fetch({
      url: `/contract/api/contract/header/finish/${id}`,
      method: 'PUT',
    });
  },
  // 删除合同
  deleteContract(id) {
    return fetch({
      url: `/contract/api/contract/header/v2/${id}`,
      method: 'DELETE',
      data: { id },
    });
  },
  // 获取授权列表
  getAuthorizeList(params) {
    return fetch({
      url: '/contract/api/contract/header/grant',
      method: 'GET',
      params,
    });
  },
  // 保存授权列表
  saveAuthorizeDetail(data) {
    return fetch({
      url: '/contract/api/contract/header/grant',
      method: 'POST',
      data,
    });
  },

  getAssociatedList(params) {
    return fetch({
      url: '/api/contract/get/all/msg',
      method: 'GET',
      params,
    });
  },

  getContractStagePaidInfo(params) {
    return fetch({
      url: '/contract/api/contract/header/getStagePaidAmount',
      method: 'GET',
      params,
    });
  },

  getContractPayList(params) {
    return fetch({
      url: '/api/contract/getContractDocmentPaydetail',
      method: 'GET',
      params,
    });
  },
  getRelateApplicationInfo(formOID, jobId, data, companyOID) {
    return fetch({
      url: `/api/contract/reference/applications/value?formOID=${formOID}&jobId=${jobId}&companyOID=${companyOID}`,
      method: 'POST',
      data,
    });
  },
  getRelateContractInfo(params) {
    return fetch({
      url: '/api/contract/reference/customFormValue',
      method: 'GET',
      params,
    });
  },
  getContractGeneratePdf(documentOID) {
    return fetch({
      url: `/api/contract/generate/pdf/${documentOID}`,
      method: 'GET',
    });
  },
  getContractLeaseInfo(params) {
    return fetch({
      url: '/contract/api/contract/lease',
      method: 'GET',
      params,
    });
  },
  deleteLeaseInfo(id) {
    return fetch({
      url: `/contract/api/contract/lease/${id}`,
      method: 'DELETE',
      nativeResponseSerializer: 'boolean',
    });
  },
  // 保存租赁信息
  saveContractLeaseInfo(data) {
    return fetch({
      url: '/contract/api/contract/lease',
      method: 'POST',
      data,
    });
  },
  getLeaseItems(params) {
    return fetch({
      url: '/api/custom/enumerations/items/by/type?page=0&size=9999',
      method: 'GET',
      params,
    });
  },
  //获取付款方式
  getPaymentMethod() {
    return fetch({
      url: '/payment/api/cash/payment/method/query/all',
      method: 'GET',
    });
  },
  //获取合同阶段信息
  getContractStageDetail(params) {
    return fetch({
      url: '/contract/api/contract/line/getContractLineByHeaderIdAndStageId',
      method: 'GET',
      params,
    });
  },
  getUserBankList(id) {
    return fetch({
      url: '/api/contact/bank/account/enable',
      method: 'GET',
      params: {
        userId: id,
      },
    });
  },
  // 根据合同OID 获取关联申请的费用行
  getReferenceApplicationBudget(params) {
    return fetch({
      url: '/api/contract/reference/application/budget',
      method: 'GET',
      params,
    });
  },
  // 导入申请单预算
  importApplicationBudget(data) {
    return fetch({
      url: '/api/contract/reference/budget/line',
      method: 'POST',
      data,
    });
  },
  // 获取合同预算行 关联的申请单预算行
  viewReferenceApplicationBudget(data) {
    return fetch({
      url: '/api/contract/query/reference/application/budget',
      method: 'POST',
      data,
    });
  },

  getSubjectMatter(entityOID) {
    return fetch({
      url: '/api/contract/subject/matter/line',
      method: 'GET',
      params: {
        isOldVersion: false,
        entityOID,
      },
    });
  },
  saveSubjectMatter(data) {
    return fetch({
      url: '/api/contract/subject/matter/line',
      method: 'POST',
      data,
    });
  },

  //获取费用表单配置
  getExpenseCustomForm(setOfBooksId, expenseTypeOID) {
    return fetch({
      url: `/api/expense/forms?modelType=4&setOfBooksId=${setOfBooksId}`,
      method: 'POST',
      data: [expenseTypeOID],
    });
  },
  // 选择合同行
  getPaymentLines(params) {
    return fetch({
      url: '/contract/api/v3/contract/document/relations/associate/query',
      method: 'GET',
      params,
    });
  },

  // 获取标的物列表
  getSubjectMatterList(data) {
    return fetch({
      url: '/api/contract/subject/matter/list',
      method: 'POST',
      data,
    });
  },

  // 合同续签自
  getRelationContract(headId) {
    return fetch({
      url: '/contract/api/contract/header/relation/contract',
      method: 'GET',
      params: {
        headId,
      },
    });
  },
  // 合同变更自
  getContractChangeFrom(headId) {
    return fetch({
      url: '/contract/api/contract/header/change/from',
      method: 'GET',
      params: {
        headId,
      },
    });
  },
  // 历史合同
  getHistoryContract(params) {
    return fetch({
      url: '/contract/api/contract/header/query/history/by/partner',
      method: 'GET',
      params,
    });
  },
  getArchiveTypes(params) {
    return fetch({
      url: '/contract/api/contract/option/getFinanceContractOption',
      method: 'GET',
      params,
    });
  },

  // 合同归档
  filedContract(data) {
    return fetch({
      url: '/contract/api/contract/header/contract/archive',
      method: 'PUT',
      data,
    });
  },

  // 更新合同归档附件
  updateArchiveAttachment(data) {
    return fetch({
      url: '/contract/api/contract/header/contract/archive/attachment/update',
      method: 'PUT',
      data,
    });
  },

  // 获取合同行自定义配置
  getContractStandardLineList(params) {
    const { formType, formOID, page, size } = params;
    return fetch({
      url: `/api/obj/standard/line/field/page?type=${formType}&formOID=${formOID}&page=${page}&size=${size}`,
      method: 'GET',
    });
  },
};
